// src/components/bot/components/BotFormHeader.tsx
// 🎨 FORM HEADER COMPONENT - Title and action buttons (50 lines)

import React from 'react';
import styles from '../BotForm.module.css';

interface BotFormHeaderProps {
  isEdit: boolean;
  onCancel?: () => void;
  saving: boolean;
  templateLoading: boolean;
  onSubmit?: () => void; // Made optional since form handles submission
}

const BotFormHeader: React.FC<BotFormHeaderProps> = ({
  isEdit,
  onCancel,
  saving,
  templateLoading,
  onSubmit
}) => {
  return (
    <div className={styles.formHeaderWide}>
      <div>
        <h1>{isEdit ? 'Edit Bot' : 'Create New Bot'}</h1>
        <p>
          Set up bots that automatically send WhatsApp template messages or collect 
          information through questionnaires when clients message you with specific keywords
        </p>
      </div>
      <div className={styles.headerActions}>
        {onCancel && (
          <button 
            type="button" 
            onClick={onCancel} 
            className={styles.cancelBtn} 
            disabled={saving}
          >
            Cancel
          </button>
        )}
        <button 
          type="submit"
          className={styles.submitBtn} 
          disabled={saving || templateLoading}
        >
          {saving ? 'Saving...' : (isEdit ? 'Update Bot' : 'Create Bot')}
        </button>
      </div>
    </div>
  );
};

export default BotFormHeader;